import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import APIKeysCreatePage from './APIKeysCreatePage';

export default flowRight(withVerificationGuard, withAuthGuard())(APIKeysCreatePage);
